import { StepStructure } from '../../../components';

const REQUEST: StepStructure = {
  title: 'Заявка',
  description:
    'Отправьте заявку, мы\u00A0перезвоним и\u00A0проконсультируем, а\u00A0также договоримся о\u00A0выезде для замера.',
};

const WATER_ANALYSIS: StepStructure = {
  title: 'Анализ воды',
  description:
    'Приедем и\u00A0заберём пробы воды для анализа на\u00A0показатели, необходимые для подбора оборудования.',
};

const PROJECT: StepStructure = {
  title: 'Проект',
  description:
    'Подберём варианты оборудования, составим спецификацию с\u00A0ценами и\u00A0материалами, подготовим смету на\u00A0монтажные работы.',
};

const MOUNTING: StepStructure = {
  title: 'Монтаж',
  description:
    'Выполним монтаж и\u00A0проверим качество воды. Дадим гарантию на\u00A0установку и\u00A0качество воды.',
};

export const FILTER_STEP_LIST_WITH_WATER_ANALYSIS: StepStructure[] = [
  REQUEST,
  WATER_ANALYSIS,
  PROJECT,
  MOUNTING,
];

export const FILTER_STEP_LIST_WITHOUT_WATER_ANALYSIS: StepStructure[] = [REQUEST, PROJECT, MOUNTING];
